import {Params} from '../getConfig'

export const amplifyElalStaging: Params = {
  aws_user_pools_id: 'eu-west-1_h57VtBiCB',
  aws_cognito_identity_pool_id: '', // Not needed for any partner
  aws_user_pools_web_client_id: '1n56b6msbg61lq47pabopc6itc',
  oauth_domain: 'elal-auth-staging.auth.eu-west-1.amazoncognito.com',
  aws_user_files_s3_bucket: '' // Not needed for any partner
}
